<template>
  <main id="app">
    <div class="container-fluid">
      <router-view></router-view>
    </div>
  </main>
</template>

<script>
  // import { TRY_AUTO_LOGIN } from './store/types'

  export default {
    name: 'app'
    // created() {
    //   this.$store.dispatch(TRY_AUTO_LOGIN)
    // }
  }
</script>

<style lang="scss">

</style>
